package b2d

import abilities.*
import b2d.userdata.*
import component.*
import org.jbox2d.callbacks.*
import org.jbox2d.collision.*
import org.jbox2d.dynamics.contacts.*

class WorldContactListener : ContactListener {
    override fun beginContact(contact: Contact) {
        val fixA = contact.getFixtureA() ?: return
        val fixB = contact.getFixtureB() ?: return

        val cDef = fixA.filterData.categoryBits or fixB.filterData.categoryBits
        when (cDef) {
            B2dParameters.PLAYER_GROUND_SENSOR or B2dParameters.GROUND_BIT -> {
                if (fixA.filterData.categoryBits == B2dParameters.PLAYER_GROUND_SENSOR) {
                    (fixA.userData as PlayerPhysicState).addGroundContact(fixB)
                } else {
                    (fixB.userData as PlayerPhysicState).addGroundContact(fixA)
                }
            }
            B2dParameters.PLAYER_BIT or B2dParameters.WALL_LEFT_BIT -> {
                if (fixA.filterData.categoryBits == B2dParameters.PLAYER_BIT) {
                    (fixA.userData as PlayerPhysicState).addWallLeftContact(fixB)
                } else {
                    (fixB.userData as PlayerPhysicState).addWallLeftContact(fixA)
                }
            }
            B2dParameters.PLAYER_BIT or B2dParameters.WALL_RIGHT_BIT -> {
                if (fixA.filterData.categoryBits == B2dParameters.PLAYER_BIT) {
                    (fixA.userData as PlayerPhysicState).addWallRightContact(fixB)
                } else {
                    (fixB.userData as PlayerPhysicState).addWallRightContact(fixA)
                }
            }
            B2dParameters.PLAYER_BIT or B2dParameters.WATER_BIT -> {
                if (fixA.filterData.categoryBits == B2dParameters.WATER_BIT) {
                    (fixA.userData as Water).applyToPlayer(fixB.userData as PlayerPhysicState)
                } else {
                    (fixB.userData as Water).applyToPlayer(fixA.userData as PlayerPhysicState)
                }
            }
            B2dParameters.PLAYER_BIT or B2dParameters.FINISH_BIT -> {
                if (fixA.filterData.categoryBits == B2dParameters.FINISH_BIT) {
                    (fixA.userData as Finish).playerFinished(1L)
                } else {
                    (fixB.userData as Finish).playerFinished(1L)
                }
            }
            B2dParameters.PLAYER_BIT or B2dParameters.FIRE_BOLT_SENSOR_BIT -> {
                if (fixA.filterData.categoryBits == B2dParameters.PLAYER_BIT) {
                    (fixB.userData as FireBolt).addTarget(fixA.userData as PlayerPhysicState)
                } else {
                    (fixA.userData as FireBolt).addTarget(fixB.userData as PlayerPhysicState)
                }
            }

            B2dParameters.PLAYER_BIT or B2dParameters.FIRE_BOLT_BIT -> {
                if (fixA.filterData.categoryBits == B2dParameters.PLAYER_BIT) {
                    (fixB.userData as FireBolt).hit()
                } else {
                    (fixA.userData as FireBolt).hit()
                }
            }

            B2dParameters.FIRE_BOLT_BIT or B2dParameters.GROUND_BIT -> {
                if (fixA.filterData.categoryBits == B2dParameters.FIRE_BOLT_BIT) {
                    (fixA.userData as FireBolt).hit()
                } else {
                    (fixB.userData as FireBolt).hit()
                }
            }

            B2dParameters.PLAYER_BIT or B2dParameters.TRAP_BIT -> {
                if (fixA.filterData.categoryBits == B2dParameters.PLAYER_BIT) {
                    (fixA.userData as PlayerPhysicState).addTrapContact(fixB)
                    (fixB.userData as TrapUserData).setTouched(true)
                } else {
                    (fixB.userData as PlayerPhysicState).addTrapContact(fixA)
                    (fixA.userData as TrapUserData).setTouched(true)
                }
            }

            B2dParameters.PLAYER_BIT or B2dParameters.COIN_BIT -> {
                if (fixA.filterData.categoryBits == B2dParameters.PLAYER_BIT) {
                    (fixA.userData as PlayerPhysicState).addCoin((fixB.userData as CoinComponent))
                } else {
                    (fixB.userData as PlayerPhysicState).addCoin(fixA.userData as CoinComponent)
                }
            }
        }
    }

    override fun endContact(contact: Contact) {
        val fixA = contact.getFixtureA() ?: return
        val fixB = contact.getFixtureB() ?: return

        val cDef = fixA.filterData.categoryBits or fixB.filterData.categoryBits
        when (cDef) {
            B2dParameters.PLAYER_GROUND_SENSOR or B2dParameters.GROUND_BIT -> {
                if (fixA.filterData.categoryBits == B2dParameters.PLAYER_GROUND_SENSOR) {
                    (fixA.userData as PlayerPhysicState).removeGroundContact(fixB)
                } else {
                    (fixB.userData as PlayerPhysicState).removeGroundContact(fixA)
                }
            }
            B2dParameters.PLAYER_BIT or B2dParameters.WALL_LEFT_BIT -> {
                if (fixA.filterData.categoryBits == B2dParameters.PLAYER_BIT) {
                    (fixA.userData as PlayerPhysicState).removeWallLeftContact(fixB)
                } else {
                    (fixB.userData as PlayerPhysicState).removeWallLeftContact(fixA)
                }
            }
            B2dParameters.PLAYER_BIT or B2dParameters.WALL_RIGHT_BIT -> {
                if (fixA.filterData.categoryBits == B2dParameters.PLAYER_BIT) {
                    (fixA.userData as PlayerPhysicState).removeWallRightContact(fixB)
                } else {
                    (fixB.userData as PlayerPhysicState).removeWallRightContact(fixA)
                }
            }
            B2dParameters.PLAYER_BIT or B2dParameters.FIRE_BOLT_SENSOR_BIT -> {
                if (fixA.filterData.categoryBits == B2dParameters.PLAYER_BIT) {
                    (fixB.userData as FireBolt).removePlayer(fixA.userData as PlayerPhysicState)
                } else {
                    (fixA.userData as FireBolt).removePlayer(fixB.userData as PlayerPhysicState)
                }
            }

            B2dParameters.PLAYER_BIT or B2dParameters.WATER_BIT -> {
                if (fixA.filterData.categoryBits == B2dParameters.WATER_BIT) {
                    (fixA.userData as Water).removeFromPlayer(fixB.userData as PlayerPhysicState)
                } else {
                    (fixB.userData as Water).removeFromPlayer(fixA.userData as PlayerPhysicState)
                }
            }
            B2dParameters.PLAYER_BIT or B2dParameters.TRAP_BIT -> {
                if (fixA.filterData.categoryBits == B2dParameters.PLAYER_BIT) {
                    (fixA.userData as PlayerPhysicState).removeTrapContact(fixB)
                } else {
                    (fixB.userData as PlayerPhysicState).removeTrapContact(fixA)
                }
            }
        }
    }

    override fun postSolve(contact: Contact, impulse: ContactImpulse) {

    }

    override fun preSolve(contact: Contact, oldManifold: Manifold) {

    }
}
